import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class PredefinedProfession extends Enum {
  id!: number;
  key!: string;
  value!: string;

  static ACCOUNTANT: PredefinedProfession = {
    id: 1,
    key: 'accountant',
    get value(): string {
      return Lang.t('professional.accountant');
    }
  };

  static FUNERAL_DIRECTOR: PredefinedProfession = {
    id: 2,
    key: 'funeral_director',
    get value(): string {
      return Lang.t('professional.funeral-director');
    }
  };

  static INSURANCE_BROKER: PredefinedProfession = {
    id: 3,
    key: 'insurance_broker',
    get value(): string {
      return Lang.t('professional.insurance-broker');
    }
  };

  static LAWYER: PredefinedProfession = {
    id: 4,
    key: 'lawyer',
    get value(): string {
      return Lang.t('professional.lawyer');
    }
  };

  static NOTARY: PredefinedProfession = {
    id: 5,
    key: 'notary',
    get value(): string {
      return Lang.t('professional.notary');
    }
  };

  static REAL_ESTATE_AGENT: PredefinedProfession = {
    id: 6,
    key: 'real_estate_agent',
    get value(): string {
      return Lang.t('professional.real-estate-agent');
    }
  };

  static BANK_ADMIN: PredefinedProfession = {
    id: 7,
    key: 'bank_admin',
    get value(): string {
      return Lang.t('professional.bank-admin');
    }
  };

  static BANK_CASE_MANAGER: PredefinedProfession = {
    id: 8,
    key: 'bank_case_manager',
    get value(): string {
      return Lang.t('professional.bank-case-manager');
    }
  };

  static GUARDIAN: PredefinedProfession = {
    id: 9,
    key: 'guardian',
    get value(): string {
      return Lang.t('professional.case-manager-professional');
    }
  };

  static JUNIOR_ESTATE_PROFESSIONAL: PredefinedProfession = {
    id: 10,
    key: 'junior_estate_professional',
    get value(): string {
      return Lang.t('professional.junior-estate-professional');
    }
  };

  static ESTATE_PROFESSIONAL: PredefinedProfession = {
    id: 11,
    key: 'estate_professional',
    get value(): string {
      return Lang.t('estate.estate-professional');
    }
  };

  static FINANCIAL_ADVISOR: PredefinedProfession = {
    id: 12,
    key: 'financial_advisor',
    get value(): string {
      return Lang.t('professional.financial-advisor');
    }
  };

  /**
   * deprecated
   */
  static ESTATE_COORDINATOR: PredefinedProfession = {
    id: 13,
    key: 'estate_coordinator',
    get value(): string {
      return Lang.t('professional.estate-coordinator');
    }
  };

  static TRUST_OFFICER: PredefinedProfession = {
    id: 14,
    key: 'trust_officer',
    get value(): string {
      return Lang.t('professional.trust-officer');
    }
  };

  static FINANCIAL_ADVISOR_ASSISTANT: PredefinedProfession = {
    id: 15,
    key: 'financial_advisor_assistant',
    get value(): string {
      return Lang.t('professional.assistant-financial-advisor');
    }
  };

  static ASSOCIATE_FINANCIAL_ADVISOR: PredefinedProfession = {
    id: 16,
    key: 'associate_financial_advisor',
    get value(): string {
      return Lang.t('professional.associate-financial-advisor');
    }
  };

  static TRUST_MANAGER: PredefinedProfession = {
    id: 17,
    key: 'trust_manager',
    get value(): string {
      return Lang.t('professional.trust-manager');
    }
  };

  // Temporary - Add new professions above this
  static CUSTOM_PARALEGAL: PredefinedProfession = {
    id: 99,
    key: 'custom_paralegal',
    get value(): string {
      return Lang.t('professional.paralegal');
    }
  };

  static getEstateProfessionalProfessionIds(): number[] {
    return [this.JUNIOR_ESTATE_PROFESSIONAL.id, this.ESTATE_PROFESSIONAL.id];
  }

  static getEstateProfessionalAndCoordinatorIds(): number[] {
    return [this.ESTATE_PROFESSIONAL.id, this.ESTATE_COORDINATOR.id];
  }

  static getAssignableToEstateProfessionIds(): number[] {
    return [
      this.ACCOUNTANT.id,
      this.LAWYER.id,
      this.NOTARY.id,
      this.JUNIOR_ESTATE_PROFESSIONAL.id,
      this.ESTATE_PROFESSIONAL.id,
      this.TRUST_MANAGER.id,
      this.TRUST_OFFICER.id,
      this.CUSTOM_PARALEGAL.id
    ];
  }

  static getFinancialAdvisorProfessionGroupIds(): number[] {
    return [
      this.FINANCIAL_ADVISOR.id,
      this.FINANCIAL_ADVISOR_ASSISTANT.id,
      this.ASSOCIATE_FINANCIAL_ADVISOR.id
    ];
  }
}
